import { useEffect, useState } from "react";
import QuickContactDialog from "./QuickContactDialog";
import ItemShops from "../ItemShops";
import { useNavigate } from "react-router-dom";
import { ref, get, query, orderByChild, limitToLast } from "firebase/database";
import { database } from "../../firebase/firebaseConfig";
import ItemShopShimmer from "./ItemShopShimmer";
import { usersDbRef } from "../../utils/dbRefs";
import ShopDetailsModal from "./ShopDetailsModal";

export default function FeaturedBusinesses() {
    const [isQuickContactOpen, setIsQuickContactOpen] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedShop, setSelectedShop] = useState(null);
    const [shops, setShops] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     const fetchShops = async () => {
    //         try {
    //             setLoading(true);

    //             const usersRef = query(
    //                 usersDbRef,
    //                 orderByChild("createdAt"),
    //                 limitToLast(20) // get latest users first
    //             );

    //             const snapshot = await get(usersRef);

    //             if (!snapshot.exists()) {
    //                 setShops([]);
    //                 return;
    //             }

    //             const data = snapshot.val();


    //             const shopsList = Object.values(data)
    //                 .filter((user) => user.status === "approved" && user.type !== "admin")
    //                 .sort((a, b) => b.createdAt - a.createdAt)
    //                 .slice(0, 3);

    //             setShops(shopsList);

    //         } catch (error) {
    //             console.error("Error fetching shops:", error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchShops();
    // }, []);

    const openQuickContact = (shop) => {
        setIsQuickContactOpen(true);
        setSelectedShop(shop);
    }

    const closeQuickContact = () => {
        setIsQuickContactOpen(false);
        setSelectedShop(null);
    }

    const openMoreInfo = (shop) => {
        setSelectedShop(shop);
        setShowDetails(true);
    };

    const closeMoreInfo = () => {
        setShowDetails(false);
        setSelectedShop(null);
    }


    return (
        <section className="max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[32px] md:py-[48px] flex flex-col gap-[24px]">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-[12px]">
                <div>
                    <h2 className="font-semibold text-[22px] text-[#212326] mb-[4px]">Featured businesses</h2>
                    {/* <p className="font-medium text-[14px] text-[#717182]">{shops.length} businesses available</p> */}
                </div>
                <button
                    className="flex items-center gap-[6px] px-[20px] py-[10px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[14px] hover:bg-[#e64a1f] transition-colors no-underline shrink-0"
                    onClick={() => navigate("/marketplace")}
                    data-discover="true">
                    View All
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right w-[16px] h-[16px]">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </button>
            </div>

            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px]">

                {loading ? (
                    [...Array(3)].map((_, index) => (
                        <ItemShopShimmer key={index} index={index} />
                    ))
                ) : (
                    shops.map((shop, index) => (
                        <ItemShops
                            key={shop.uid}
                            shop={shop}
                            index={index}
                            openQuickContact={openQuickContact}
                            selectedShop={selectedShop}
                            navigate={navigate}
                            openMoreInfo={openMoreInfo}
                        />
                    ))
                )}

            </div> */}
            <section className="max-w-[900px] mx-auto px-6 py-5 text-center flex flex-col items-center">

                <div className="w-20 h-20 rounded-full bg-[#FFF1EC] flex items-center justify-center mb-8">
                    <span className="text-4xl">🚀</span>
                </div>

                <h1 className="text-[42px] font-bold text-[#212326] leading-tight">
                    Going Live August 17
                </h1>

                <p className="mt-6 text-lg text-[#717182] max-w-[650px] leading-8">
                    We're preparing South Africa's dedicated print marketplace.
                    Register your business today so you'll be one of the first
                    businesses customers discover when we go live.
                </p>

                <button
                    onClick={() => navigate("/onboarding/plan")}
                    className="mt-10 bg-[#ff5323] hover:bg-[#e64a1f] text-white font-semibold px-8 py-4 rounded-xl transition"
                >
                    List Your Store
                </button>

                <p className="mt-4 text-sm text-[#9298a0]">
                    Join before launch and be ready for customers from day one.
                </p>

            </section>

            <div className="flex justify-center pt-[4px]">
                <button className="flex items-center gap-[6px] px-[24px] py-[11px] rounded-[10px] font-semibold text-[14px] transition-all border border-[#e4e5e7] text-[#212326] hover:bg-[#f4f5f6] hover:border-[#c0c2c6] no-underline"
                    onClick={() => navigate("/marketplace")}
                    data-discover="true"
                >
                    Browse Marketplace
                </button>
            </div>

            {isQuickContactOpen && (
                <QuickContactDialog
                    shop={selectedShop}
                    onClose={closeQuickContact}
                />
            )}

            {showDetails && (
                <ShopDetailsModal
                    shop={selectedShop}
                    onClose={closeMoreInfo}
                    onSendFiles={() =>
                        navigate("/marketplace/upload", {
                            state: { selectedShop }
                        })
                    }
                    onQuickContact={() => {
                        closeMoreInfo();
                        openQuickContact(selectedShop);
                    }}
                />
            )}

        </section>
    );
}
